/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum VisibilityEnum {
    ALL = 'ALL',
    IMAGE_ONLY = 'IMAGE_ONLY',
}